<template>
  <v-menu
    bottom
    offset-y
    left>
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon class="mx-n1">
        <v-icon
        id="tract-context-menu-activator"
        medium
        v-bind="attrs"
        color="primary"
        data-testid="tract-table-actions"
        v-on="on">mdi-dots-vertical</v-icon>
      </v-btn>
    </template>
    <v-list id="tract-context-menu">
      <v-list-item v-for="option in options" :key="option.id" @click="option.action" :id="option.id">
        <v-avatar left>
          <v-icon color="black">{{ option.icon }}</v-icon>
        </v-avatar>
        <v-list-item-title class="subtitle-1">{{ option.label }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'TractContextMenu',

  computed: {
    options () {
      return [
        {
          label: this.$t('downloadCSV'),
          icon: 'mdi-file-delimited-outline',
          id: 'download-csv',
          action: () => this.$emit('download-csv')
        },
        {
          label: this.$t('downloadPTForm'),
          icon: 'mdi-file-pdf-box',
          id: 'download-pt-form',
          action: () => this.$emit('download-pt-form')
        }
      ]
    }
  }
}
</script>
